import {
  DASHBOARD_TYPE,
  DEFAULT_CUSTOMER_VALIDATION_STATUS,
  getListLifecycle,
} from "fieldpro-tools";
import _ from "lodash";

import { WORKSPACE_TYPES } from "containers/clients/model";
import { IClient } from "model/entities/Client";
import { IDashboard } from "model/entities/Dashboard";

export const isWorkspaceTemplate = (client?: IClient) => {
  if (!client) {
    return false;
  }
  const { workspace_type, dbname } = client;
  return (
    // admin client should be treated as a teamplate
    (workspace_type === WORKSPACE_TYPES.TEMPLATE &&
      _.startsWith(dbname, "workspace_template")) ||
    dbname === "admin"
  );
};

// Every v3 client carries a LIST lifecycle, so its mere presence says nothing.
// Validation is opted into by switching the creation rule default away from
// APPROVED, and only makes sense when FieldPro Direct runs (FP-13373).
export const isListValidationEnabled = (
  client: IClient | undefined,
  listId: string,
): boolean => {
  if (!client?.is_fieldpro_connect_enabled) {
    return false;
  }

  const listLifecycle = getListLifecycle(
    client.erp_config?.entity_lifecycles,
    listId,
  );
  const creationRule = listLifecycle?.creation_status_rules?.find(
    (rule) => rule.default_status_id,
  );

  return (
    !!creationRule &&
    creationRule.default_status_id !==
      DEFAULT_CUSTOMER_VALIDATION_STATUS.APPROVED
  );
};

export const filterDashboardsByType = (
  dashboards: IDashboard[],
  isMobile?: boolean,
): IDashboard[] => {
  if (!isMobile) {
    return dashboards;
  }

  const mobileAccessRightsDashboardTypes = new Set<string>([
    DASHBOARD_TYPE.MOBILE,
    DASHBOARD_TYPE.ON_LIST_ITEM,
    DASHBOARD_TYPE.MOBILE_ON_LIST,
    DASHBOARD_TYPE.MOBILE_ON_ACTIVITY,
    DASHBOARD_TYPE.MOBILE_AND_WEB,
  ]);

  return dashboards.filter((dashboard) =>
    mobileAccessRightsDashboardTypes.has(dashboard.type),
  );
};
